var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeammember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 64,
    width: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "teammember") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 2,
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39,19H25v0 c0-3.314,2.686-6,6-6h2C36.314,13,39,15.686,39,19L39,19z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 6,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,28H2v0 c0-3.314,2.686-6,6-6h2C13.314,22,16,24.686,16,28L16,28z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 15,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,28H49v0 c0-3.314,2.686-6,6-6h2C60.314,22,63,24.686,63,28L63,28z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 15,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 36,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,50h-6 c-6.627,0-12,5.373-12,12v0h30v0C47,55.373,41.627,50,35,50z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeammember);
export default __webpack_public_path__ + "static/media/teammember.1427705b53c3002bfe0467ddbe2527d6.svg";
export { ForwardRef as ReactComponent };